// Environment Configuration
// This file documents the available environment variables and their defaults

export const ENV_CONFIG = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  
  // Debug Mode
  // Set VITE_DEBUG_MODE=true in your .env file to enable debug mode
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true' || import.meta.env.VITE_DEBUG_MODE === '1',
  
  // Environment
  NODE_ENV: import.meta.env.NODE_ENV || 'development',
  
  // Other Feature Flags (future use)
  // ENABLE_NEW_UI: import.meta.env.VITE_ENABLE_NEW_UI === 'true',
  // ENABLE_BETA_FEATURES: import.meta.env.VITE_ENABLE_BETA_FEATURES === 'true',
} as const;

// Helper function to check if we're in development mode
export const isDevelopment = (): boolean => {
  return ENV_CONFIG.NODE_ENV === 'development';
};

// Helper function to check if we're in production mode
export const isProduction = (): boolean => {
  return ENV_CONFIG.NODE_ENV === 'production';
};

// Helper function to get environment variable with fallback
export const getEnvVar = (key: string, fallback: string = ''): string => {
  return import.meta.env[key] || fallback;
};
